(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('fastrak-drawer-shipping')) {
    customElements.define(
      'fastrak-drawer-shipping',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';
          this.refreshTimer = null;

          const drawerContent = this.closest('.drawer__content');
          if (drawerContent) {
            this.observer = new MutationObserver((mutations) => {
              const cartContentChanged = mutations.some((mutation) => !this.contains(mutation.target));
              if (cartContentChanged) this.queueRefresh();
            });
            this.observer.observe(drawerContent, { childList: true, subtree: true });
          }

          ['cart:updated', 'cart:update', 'cart:change', 'cart:refresh'].forEach((eventName) => {
            document.addEventListener(eventName, this.handleCartUpdate);
          });

          this.refresh();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          window.clearTimeout(this.refreshTimer);
          ['cart:updated', 'cart:update', 'cart:change', 'cart:refresh'].forEach((eventName) => {
            document.removeEventListener(eventName, this.handleCartUpdate);
          });
        }

        handleCartUpdate = () => {
          this.queueRefresh();
        };

        queueRefresh() {
          window.clearTimeout(this.refreshTimer);
          this.refreshTimer = window.setTimeout(() => this.refresh(), 100);
        }

        async refresh() {
          const refreshId = (this.refreshId || 0) + 1;
          this.refreshId = refreshId;

          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart.js`, {
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
              cache: 'no-store',
            });
            if (!response.ok) return;

            const cart = await response.json();
            if (refreshId !== this.refreshId) return;

            const threshold = Number.parseInt(this.dataset.threshold, 10) || 50000;
            const remaining = Math.max(threshold - cart.total_price, 0);
            const progress = Math.min((cart.total_price / threshold) * 100, 100);
            const progressColor = progress < 50 ? '#dc2626' : progress < 100 ? '#f97316' : '#16a34a';
            const drawerContent = this.closest('.drawer__content');
            const hasSpecialShipping = [...(drawerContent?.querySelectorAll('[data-shipping-classification]') || [])].some((item) => {
              const classification = item.dataset.shippingClassification;
              return classification.includes('shipping_r250') || classification.includes('panel') || classification.includes('television') || /\btv\b/.test(classification);
            });

            const shouldHide = cart.item_count === 0;
            this.hidden = shouldHide;
            this.classList.toggle('hidden', shouldHide);
            this.style.setProperty('--fastrak-drawer-shipping-progress', `${progress}%`);
            this.style.setProperty('--fastrak-drawer-shipping-color', progressColor);
            this.dataset.qualified = remaining === 0 ? '1' : '0';
            this.dataset.specialShipping = String(hasSpecialShipping);

            const status = this.querySelector('[data-shipping-standard-status]');
            const progressBar = this.querySelector('[role="progressbar"]');
            if (status) {
              status.textContent = remaining > 0
                ? `Spend ${this.formatMoney(remaining)} more to receive free shipping.`
                : 'You qualify for free shipping.';
            }
            if (progressBar) progressBar.setAttribute('aria-valuenow', Math.round(progress));
          } catch (error) {
            return;
          }
        }

        formatMoney(cents) {
          const [rands, centsValue] = (cents / 100).toFixed(2).split('.');
          return `R ${rands.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${centsValue}`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('fastrak-cart-shipping')) {
    customElements.define(
      'fastrak-cart-shipping',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';
          this.refreshTimer = null;

          const cartItems = this.closest('.cart')?.querySelector('cart-items');
          if (cartItems) {
            this.observer = new MutationObserver(() => this.queueRefresh());
            this.observer.observe(cartItems, { childList: true, subtree: true });
          }

          ['cart:updated', 'cart:update', 'cart:change', 'cart:refresh'].forEach((eventName) => {
            document.addEventListener(eventName, this.handleCartUpdate);
          });

          this.refresh();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          window.clearTimeout(this.refreshTimer);
          ['cart:updated', 'cart:update', 'cart:change', 'cart:refresh'].forEach((eventName) => {
            document.removeEventListener(eventName, this.handleCartUpdate);
          });
        }

        handleCartUpdate = () => {
          this.queueRefresh();
        };

        queueRefresh() {
          window.clearTimeout(this.refreshTimer);
          this.refreshTimer = window.setTimeout(() => this.refresh(), 100);
        }

        async refresh() {
          const refreshId = (this.refreshId || 0) + 1;
          this.refreshId = refreshId;

          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart.js`, {
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
              cache: 'no-store',
            });
            if (!response.ok) return;

            const cart = await response.json();
            if (refreshId !== this.refreshId) return;

            const threshold = Number.parseInt(this.dataset.threshold, 10) || 50000;
            const remaining = Math.max(threshold - cart.total_price, 0);
            const progress = Math.min((cart.total_price / threshold) * 100, 100);
            const progressColor = progress < 50 ? '#dc2626' : progress < 100 ? '#f97316' : '#16a34a';
            const cartSection = this.closest('.cart');
            const hasSpecialShipping = [...(cartSection?.querySelectorAll('[data-shipping-classification]') || [])].some((item) => {
              const classification = item.dataset.shippingClassification;
              return classification.includes('shipping_r250') || classification.includes('panel') || classification.includes('television') || /\btv\b/.test(classification);
            });
            const delivery = hasSpecialShipping ? 25000 : cart.total_price < threshold ? 5000 : 0;
            const shouldHide = cart.item_count === 0;

            this.hidden = shouldHide;
            this.classList.toggle('hidden', shouldHide);
            this.style.setProperty('--fastrak-shipping-progress', `${progress}%`);
            this.style.setProperty('--fastrak-shipping-color', progressColor);
            this.dataset.qualified = remaining === 0 ? '1' : '0';
            this.dataset.specialShipping = String(hasSpecialShipping);

            const status = this.querySelector('[data-shipping-standard-status]');
            const progressBar = this.querySelector('[role="progressbar"]');
            const deliveryValue = cartSection?.querySelector('[data-fastrak-delivery]');
            const totalValue = cartSection?.querySelector('[data-fastrak-total-delivery]');

            if (status) {
              status.textContent = remaining > 0
                ? `Spend ${this.formatMoney(remaining)} more to receive free shipping.`
                : 'You qualify for free shipping.';
            }
            if (progressBar) progressBar.setAttribute('aria-valuenow', Math.round(progress));
            if (deliveryValue) deliveryValue.textContent = delivery === 0 ? 'FREE' : this.formatMoneyWithCurrency(delivery);
            if (totalValue) totalValue.textContent = this.formatMoneyWithCurrency(cart.total_price + delivery);
          } catch (error) {
            return;
          }
        }

        formatMoney(cents) {
          const [rands, centsValue] = (cents / 100).toFixed(2).split('.');
          return `R ${rands.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${centsValue}`;
        }

        formatMoneyWithCurrency(cents) {
          return `${this.formatMoney(cents)} ZAR`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('fastrak-fulfilment')) {
    customElements.define(
      'fastrak-fulfilment',
      class extends HTMLElement {
        connectedCallback() {
          const productInfo = this.closest('product-info');
          const stickyInformation = productInfo?.querySelector('.product__info-container');

          if (stickyInformation && this.parentElement !== stickyInformation) {
            stickyInformation.appendChild(this);
            return;
          }

          if (this.dataset.locationReady === 'true') return;
          this.dataset.locationReady = 'true';

          this.querySelector('[data-find-nearest-stores]')?.addEventListener('click', (event) => {
            this.findNearestStores(event.currentTarget);
          });
        }

        findNearestStores(button) {
          const status = this.querySelector('[data-location-status]');
          const details = this.querySelector('[data-store-details]');
          const list = this.querySelector('[data-store-list]');
          const stores = [...(list?.querySelectorAll('[data-store-location]') || [])];

          if (!navigator.geolocation) {
            status.textContent = 'Location access is not supported by this browser. You can still view all available stores.';
            return;
          }

          button.disabled = true;
          status.textContent = 'Finding your closest available stores…';

          navigator.geolocation.getCurrentPosition(
            ({ coords }) => {
              const rankedStores = stores
                .map((store) => {
                  const latitude = Number.parseFloat(store.dataset.latitude);
                  const longitude = Number.parseFloat(store.dataset.longitude);
                  const distance = Number.isFinite(latitude) && Number.isFinite(longitude)
                    ? this.distanceInKilometres(coords.latitude, coords.longitude, latitude, longitude)
                    : Number.POSITIVE_INFINITY;

                  return { store, distance };
                })
                .sort((a, b) => a.distance - b.distance);

              const locatedStores = rankedStores.filter(({ distance }) => Number.isFinite(distance));

              if (locatedStores.length === 0) {
                status.textContent = 'We could not calculate the distance to these stores. You can still view the full availability list.';
                button.disabled = false;
                details.open = true;
                return;
              }

              rankedStores.forEach(({ store, distance }, index) => {
                list.appendChild(store);
                store.hidden = index >= 5 || !Number.isFinite(distance);

                const distanceLabel = store.querySelector('[data-store-distance]');
                if (distanceLabel && Number.isFinite(distance)) {
                  distanceLabel.hidden = false;
                  distanceLabel.textContent = `${distance < 10 ? distance.toFixed(1) : Math.round(distance)} km away`;
                }
              });

              details.querySelector('summary').textContent = 'Closest available stores';
              details.open = true;
              status.textContent = `Showing the ${Math.min(5, locatedStores.length)} closest stores with confirmed pickup availability.`;
              button.textContent = 'Location updated';
              button.disabled = false;
            },
            () => {
              status.textContent = 'We could not access your location. You can still view all available stores.';
              button.disabled = false;
            },
            { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
          );
        }

        distanceInKilometres(startLatitude, startLongitude, endLatitude, endLongitude) {
          const toRadians = (degrees) => degrees * (Math.PI / 180);
          const latitudeDifference = toRadians(endLatitude - startLatitude);
          const longitudeDifference = toRadians(endLongitude - startLongitude);
          const calculation =
            Math.sin(latitudeDifference / 2) ** 2 +
            Math.cos(toRadians(startLatitude)) *
              Math.cos(toRadians(endLatitude)) *
              Math.sin(longitudeDifference / 2) ** 2;

          return 6371 * 2 * Math.atan2(Math.sqrt(calculation), Math.sqrt(1 - calculation));
        }
      }
    );
  }

  if (!customElements.get('fastrak-product-delivery-summary')) {
    customElements.define(
      'fastrak-product-delivery-summary',
      class extends HTMLElement {
        connectedCallback() {
          const taxSummary = this.closest('product-info')?.querySelector('.product__tax');
          if (taxSummary && this.parentElement !== taxSummary) taxSummary.append(this);
        }
      }
    );
  }

  if (!customElements.get('fastrak-purchase-reassurance')) {
    customElements.define(
      'fastrak-purchase-reassurance',
      class extends HTMLElement {
        connectedCallback() {
          const purchaseBlock = this.closest('product-info')?.querySelector('.product__block--buy_buttons');
          if (purchaseBlock && this.parentElement !== purchaseBlock) purchaseBlock.append(this);
        }
      }
    );
  }

  if (!customElements.get('fastrak-purchase-help')) {
    customElements.define('fastrak-purchase-help', class extends HTMLElement {
      connectedCallback() {
        const block = this.closest('product-info')?.querySelector('.product__block--buy_buttons');
        if (block && this.parentElement !== block) block.append(this);
      }
    });
  }

  if (!customElements.get('fastrak-description-formatter')) {
    customElements.define(
      'fastrak-description-formatter',
      class extends HTMLElement {
        connectedCallback() {
          const productInfo = this.closest('product-info');
          if (!productInfo) return;

          productInfo
            .querySelectorAll('.product__block--collapsible_tab .accordion-details__content.rte')
            .forEach((description) => this.formatDescription(description));
        }

        formatDescription(description) {
          if (description.dataset.fastrakFormatted === 'true') return;

          const directHeadings = [...description.children].filter((element) => /^H[2-4]$/.test(element.tagName));
          const recognisedHeadings = directHeadings.filter((heading) => this.getSectionLabel(heading.textContent));
          if (recognisedHeadings.length < 2) return;

          const productTitle = this.normalise(this.dataset.productTitle);
          const firstElement = description.firstElementChild;
          if (firstElement && /^H[1-3]$/.test(firstElement.tagName) && this.normalise(firstElement.textContent) === productTitle) {
            firstElement.remove();
          }

          const originalNodes = [...description.childNodes];
          const fragment = document.createDocumentFragment();
          const intro = document.createElement('div');
          intro.className = 'fastrak-description-intro';
          let currentContent = intro;
          let sectionCount = 0;

          originalNodes.forEach((node) => {
            const label = node.nodeType === Node.ELEMENT_NODE && /^H[2-4]$/.test(node.tagName)
              ? this.getSectionLabel(node.textContent)
              : null;

            if (!label) {
              currentContent.append(node);
              return;
            }

            const details = document.createElement('details');
            details.className = 'fastrak-description-accordion';
            if (sectionCount === 0) details.open = true;

            const summary = document.createElement('summary');
            summary.className = 'fastrak-description-accordion__summary';
            summary.textContent = label;

            currentContent = document.createElement('div');
            currentContent.className = 'fastrak-description-accordion__content';
            details.append(summary, currentContent);
            fragment.append(details);
            node.remove();
            sectionCount += 1;
          });

          if (intro.textContent.trim() || intro.querySelector('img, video, iframe, table, ul, ol')) fragment.prepend(intro);
          description.replaceChildren(fragment);
          description.dataset.fastrakFormatted = 'true';
        }

        getSectionLabel(value) {
          const heading = this.normalise(value).replace(/[?:]+$/, '');
          if (/^(key )?features?$/.test(heading)) return 'Key features';
          if (/^(technical )?specifications?$/.test(heading)) return 'Specifications';
          if (/^what'?s in the box$/.test(heading)) return "What's in the box";
          if (/^dimensions? (&|and) weight$/.test(heading)) return 'Dimensions & weight';
          if (/^(product )?warranty( information)?$/.test(heading)) return 'Warranty';
          return null;
        }

        normalise(value) {
          return String(value || '')
            .toLowerCase()
            .replace(/[’‘]/g, "'")
            .replace(/\s+/g, ' ')
            .trim();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
